import {
  Address,
  Cart,
  Consignment,
  Coupon,
  Customer,
  GiftCertificate,
  PaymentMethod,
  ShippingOption,
  Tax,
} from '@bigcommerce/checkout-sdk';

export enum EBIZIO_EVENT_TYPE {
  CHECKOUT_LOADED = 'CHECKOUT_LOADED',
  CUSTOMER_SIGNED_IN = 'CUSTOMER_SIGNED_IN',
  CUSTOMER_SIGNED_OUT = 'CUSTOMER_SIGNED_OUT',
  CUSTOMER_STEP_LOADING = 'CUSTOMER_STEP_LOADING',
  SHIPPING_STEP_LOADING = 'SHIPPING_STEP_LOADING',
  BILLING_STEP_LOADING = 'BILLING_STEP_LOADING',
  PAYMENT_STEP_LOADING = 'PAYMENT_STEP_LOADING',
  SHIPPING_METHOD_SELECTED = 'SHIPPING_METHOD_SELECTED',
  SAVED_SHIPPING_ADDRESS_CHANGED = 'SAVED_SHIPPING_ADDRESS_CHANGED',
  USE_NEW_SHIPPING_ADDRESS_SELECTED = 'USE_NEW_SHIPPING_ADDRESS_SELECTED',
  STORE_CREDIT_TOGGLED = 'STORE_CREDIT_TOGGLED',
  PAYMENT_METHOD_LOADED = 'PAYMENT_METHOD_LOADED',
  PAYMENT_METHOD_SELECTED = 'PAYMENT_METHOD_SELECTED',
  COUPONS_CHANGED = 'COUPONS_CHANGED',
  GIFT_CERTIFICATES_CHANGED = 'GIFT_CERTIFICATES_CHANGED',
  CART_SUMMARY_MODAL_OPENED = 'CART_SUMMARY_MODAL_OPENED',
}

export interface EbizioEventConfig {
  event: EBIZIO_EVENT_TYPE;
  handler: EbizioEventHandler;
}

export interface EbizioAccess {
  customerGroupPaymentRestrictions: boolean;
  customerGroupShippingRestrictions: boolean;
  destinationBasedProductFees: boolean;
  eventManager: boolean;
  productFees: boolean;
  purchaseOrder: boolean;
  shipOnAccount: boolean;
  styleEditor: boolean;
  textEditor: boolean;
  dittopay: boolean;
}

export enum CheckoutStepType {
  Billing = 'billing',
  Customer = 'customer',
  Payment = 'payment',
  Shipping = 'shipping',
}

export interface EbizioEventDetails {
  access: EbizioAccess;
  activeStepType: CheckoutStepType | undefined;
  cart: Cart | undefined;
  coupons: Coupon[] | undefined;
  customer: Customer;
  customerMessage: string;
  billingAddress: Address | undefined;
  giftCertificates: GiftCertificate[];
  isStoreCreditApplied: boolean;
  selectedShippingOption: ShippingOption | undefined;
  selectedPaymentMethod: PaymentMethod | null;
  shippingAddress: Address | undefined;
  shippingCostTotal: number | null;
  consignments: Consignment[] | null;
  grandTotal: number | null;
  taxTotal: number | null;
  taxes: Tax[];
  refreshCartData: () => Promise<void>;
}

export type EbizioEvent = CustomEvent<EbizioEventDetails>;

export interface EbizioEventHandler {
  (event: EbizioEvent): void;
}
